<template>
  <div>
    <b-modal
      id="modal-payment"
      class="custom-modal2"
      :hide-footer="true"
      modal-class="custom-modal2 no-animation"
      content-class="rectangular-dark-blue-modal-no-shadow"
      @shown="onOpen"
    >
      <template slot="modal-header">
        <a href="#" class="close-button" @click="onClose"> </a>
        <div
          class="head-icon to-center-abs bg-img"
          :style="{
            backgroundImage:
              'url(' + $whitelabel.assets.features.shop.visual + ')',
          }"
        ></div>
      </template>

      <template slot="default">
        <div v-if="shopChosenPackage" class="container-fluid h-100">
          <b-row class="p-0 m-0 h-100">
            <b-col
              cols="5"
              class="position-relative h-100 py-3 d-flex flex-column align-items-center justify-content-between"
            >
              <div
                class="back-option clickable position-absolute"
                @click="onClose"
              >
                <div class="back-arrow"></div>
                <div class="back-text">
                  {{ $t(`shop.payment.back`) }}
                </div>
              </div>
              <div class="headline1 bold text-uppercase">
                {{ $t(`shop.payment.header1`) }}
              </div>

              <div
                v-if="packageName"
                class="package-name glow text-center bold text-uppercase"
              >
                {{ packageName }}
              </div>
              <div
                v-else
                class="package-name glow bold text-uppercase text-center"
              >
                {{ $t("header.offer") }}
              </div>
              <div
                v-if="
                  packageName &&
                  shopChosenPackage &&
                  !shopChosenPackage.customImg
                "
                class="package-image position-relative"
              >
                <img
                  draggable="false"
                  :src="getImageSrc(shopChosenPackage.package.slug)"
                  class="h-100"
                />
                <div
                  v-if="getMoreContentLabel(shopChosenPackage)"
                  class="shop-more-percent position-absolute"
                >
                  {{ getMoreContentLabel(shopChosenPackage).value }}
                </div>
              </div>
              <div
                v-if="shopChosenPackage && shopChosenPackage.customImg"
                class="package-image"
              >
                <img
                  draggable="false"
                  :src="getImageSrc(shopChosenPackage.customImg)"
                  class="h-100"
                />
              </div>
              <div
                v-for="(currency, index) in mainCurrencies"
                :key="index"
                class="package-amount glow w-100 bold text-center relative d-inline-flex align-items-center justify-content-center"
              >
                <div :key="index">
                  {{ formatNumber(shopChosenPackage.rewards[currency]) }}
                  x

                  <BaseAsset
                    :asset="getAsset(currency)"
                    class="ms-1"
                    size="big"
                  ></BaseAsset>
                </div>
              </div>

              <div class="glow-box glowing-border">
                <div
                  class="package-bonus-text glow bold text-center text-uppercase"
                >
                  {{ $t(`shop.header.bonus`) }}
                </div>
                <div
                  v-if="shopChosenPackage && shopChosenPackage.rewards"
                  class="w-100 px-3"
                >
                  <b-row no-gutters align-v="center" align-h="center">
                    <template v-for="(bonusReward, index) in bonusRewardsArray">
                      <b-col
                        v-if="bonusReward && bonusReward.amount > 0"
                        :key="bonusReward.amount + index"
                        cols="3"
                        :class="`package-bonus-icon-${bonusReward.type}`"
                        class="d-flex align-items-center justify-content-center mx-auto"
                      >
                        <div
                          class="d-flex align-items-center justify-content-center"
                        >
                          <template v-if="bonusReward.type !== 'expbooster'">
                            {{ shopChosenPackage.rewards[bonusReward.type] }}x
                          </template>
                          <template v-else>
                            {{
                              Math.round(
                                shopChosenPackage.rewards.expbooster / 60
                              )
                            }}
                            Min.</template
                          >
                        </div>
                        <BaseAsset
                          class="icon ms-1"
                          :size="
                            bonusRewardsArray.length >= 3 ? 'medium' : 'big'
                          "
                          :asset="getAsset(bonusReward.type)"
                        ></BaseAsset> </b-col
                    ></template>
                  </b-row>
                </div>
              </div>

              <div class="package-price-text bold text-uppercase">
                {{ $t(`shop.header.price`) }}
              </div>
              <div
                v-if="shopChosenPackage"
                class="package-price-amount text-center primary-accent"
              >
                € {{ formatPrice(shopChosenPackage.package.price) }}
              </div>
            </b-col>
            <b-col
              cols="7"
              class="position-relative h-100"
              style="padding-top: 80px"
            >
              <Spinner
                v-if="isPaypalLoading || isAdyenLoading"
                size="medium"
                context="Loading Payment Methods..."
                classes="dead-center"
              ></Spinner>
              <div
                id="payment-methods-scroll-container"
                class="overflow-y-scroll pb-5"
              >
                <div
                  v-show="!isAdyenLoading"
                  id="paypal-button-container"
                ></div>
                <div id="dropin"></div>
              </div>
            </b-col>
          </b-row>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import * as paymentAPI from "@/API/payment.js";
import Spinner from "@/components/animation/animation-spinner";
import paymentFunctions from "@/mixins/paymentFunctions.js";
import adyenMixin from "@/mixins/adyen.js";
import { AdyenCheckout, Dropin } from "@adyen/adyen-web/auto";
import { loadScript } from "@paypal/paypal-js";
import "@adyen/adyen-web/styles/adyen.css";
import "@/adyen-override.css";
import i18next from "i18next";
import BaseAsset from "../base/base-asset.vue";

export default {
  name: "ModalPayment",
  components: {
    BaseAsset,
    Spinner,
  },
  mixins: [paymentFunctions, adyenMixin],
  data() {
    return {
      vat: 1,
      loading: false,
      isPaypalLoading: true,
      dropinComponent: null,
      packageName: null,
      creditCardStyleObject: {
        base: {
          color: "#ffffff",
          caretColor: "#ffffff",
          backgroundColor: "#070e1d",
        },
        error: {
          color: "#ec674d",
        },
        placeholder: {
          color: "#d8d8d8",
        },
        validated: {
          color: "#00bb01",
        },
      },
      paypalButtonStyle: {
        layout: "vertical",
        color: "gold",
        shape: "rect",
        label: "paypal",
      },
    };
  },

  methods: {
    async onOpen() {
      this.$store.commit("shop/setPaymentCompleted", false);
      this.setPackageName();
      if (this.$whitelabel.featuresEnabled.paypal) {
        this.initializePaypal();
      } else {
        this.isPaypalLoading = false;
      }
      this.$router.replace(this.$route.fullPath.split("?")[0]).catch(() => {});

      this.sessionData = await paymentAPI.getAdyenSession(this.sessionConfig);
      let config = this.initializeAdyenConfig(
        this.sessionData.adyen,
        this.sessionData.adyen.id
      );
      this.$store.commit(
        "shop/setTransactionId",
        this.sessionData.transactionId
      );
      this.$store.commit("shop/setAdyenData", this.sessionData.adyen);

      const checkout = await AdyenCheckout(config);
      this.dropinComponent = new Dropin(checkout, {
        openFirstPaymentMethod: false,

        paymentMethodsConfiguration: {
          card: {
            styles: this.creditCardStyleObject,
          },
        },
        onReady: () => {
          this.isAdyenLoading = false;
        },
      }).mount("#dropin");
    },
    onClose() {
      if (this.dropinComponent) {
        this.dropinComponent.unmount();
      }
      this.isPaypalLoading = true;
      this.isAdyenLoading = true;
      this.$store.commit("shop/clearLastPayment");
      this.$bvModal.hide("modal-payment");
    },
    initializePaypal() {
      loadScript({
        "client-id": process.env.VUE_APP_PAYPAL_CLIENT_ID,
        components: "buttons",
        currency: "EUR",
        disableFunding: "credit,card,sepa",
      })
        .then((paypal) => {
          paypal
            .Buttons({
              style: this.paypalButtonStyle,
              createOrder: async () => {
                try {
                  const res = await paymentAPI.createPaypalOrder(
                    this.shopChosenPackage.id
                  );
                  const orderData = res?.data?.data?.order;
                  if (!orderData?.id) {
                    const errorDetail = orderData?.details?.[0];
                    const errorMessage = errorDetail
                      ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                      : "Unexpected error occurred, please try again.";

                    console.error("Error: ", errorMessage);
                    throw new Error(errorMessage);
                  }
                  this.$store.commit(
                    "shop/setTransactionId",
                    res.data.data.transaction_reference
                  );
                  return orderData.id;
                } catch (error) {
                  console.error("Error creating PayPal order:", error.message);
                  throw error;
                }
              },

              onApprove: async (data) => {
                // Capture the funds from the transaction.
                const response = await paymentAPI.fetchPaypalPaymentCapture(
                  this.$store.state.shop.transactionId,
                  data.orderID
                );
                this.$store.commit("shop/setPaymentMethod", "paypal");
                this.$store.commit("shop/setPaymentStatus", "Authorised");
                this.$emit("payment-done");
                this.$bvModal.hide("modal-payment");
                this.sendPaymentAnalytics();
              },
              onCancel: (data) => {
                this.$store.commit("shop/setPaymentError", true);
                this.$store.commit("shop/setPaymentStatus", "Cancelled");
                console.warn("PayPal transaction cancelled: ", data);
              },
              onError: (err) => {
                this.$store.commit("shop/setPaymentError", true);
                this.$store.commit("shop/setPaymentStatus", "Error");
                console.error("PayPal error: ", err);
              },
            })
            .render("#paypal-button-container");
          this.isPaypalLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching PayPal session:", error);
        });
    },

    getImageSrc: function (slug) {
      try {
        return require("@/assets/img/shop/" + slug + ".png");
      } catch (e) {
        console.log(e);
        return "";
      }
    },
    setPackageName() {
      if (this.shopChosenPackage.customName) {
        this.packageName = this.shopChosenPackage.customName;
        return;
      }

      if (i18next.exists(`shop.items.${this.shopChosenPackage.package.slug}`)) {
        this.packageName = this.$t(
          `shop.items.${this.shopChosenPackage.package.slug}`
        );
        return;
      }

      this.packageName = null;
    },

    getAsset(type) {
      switch (type) {
        case "gold":
          return "primary";
        case "crown":
          return "secondary";
        case "expbooster":
          return "booster";
        case "card":
          return "cards";
        case "elixir":
          return "tertiary";
        case "loyalty":
          return "loyalty";
        default:
          return "primary";
      }
    },
  },
};
</script>
<style lang="scss">
$modal-width: 1200px;
$modal-height: 632px;

#modal-payment {
  .modal-header {
    .head-icon {
      top: -95px;
      width: 480px;
      height: 182px;
    }
  }
  #payment-methods-scroll-container {
    max-height: 480px;
    &::-webkit-scrollbar {
      height: 12px;
      width: 12px;
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: $background-dark-overlay-30;
      -webkit-border-radius: 1ex;
      -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
    }

    &::-webkit-scrollbar-corner {
      background: #000;
    }
  }

  .modal-dialog {
    top: 80px;
    max-width: $modal-width;
    height: $modal-height;

    @media (max-height: 785px) {
      transform: scale(0.8);
      top: 0;
      margin-bottom: -20%;
    }

    @media (max-height: 650px), (max-width: 1300px) {
      transform: scale(0.7);
      top: -40px;
      margin-bottom: -30%;
    }

    @media (max-width: 1100px) {
      left: -80px;
    }
  }

  .modal-content {
    width: $modal-width;
    box-shadow: 0 0 26px $text-shadow--cyan, 0 0 26px $text-shadow--cyan,
      0 0 26px $text-shadow--cyan, 0 0 26px $text-shadow--cyan,
      0 0 13px $text-shadow--cyan, 0 0 13px $text-shadow--cyan,
      0 0 6px rgba(0, 94, 110, 0.8), 0 0 6px rgba(0, 94, 110, 0.8);
    border: 2px solid white;
    border-radius: 16px;
  }

  .close-button {
    top: -80px;
    right: -50px;
  }
}
</style>

<style scoped lang="scss">
#modal-payment {
  .glow {
    text-shadow: 0 0 16px $text-shadow--cyan, 0 0 8px $text-shadow--cyan,
      0 0 8px $text-shadow--cyan, 0 0 4px rgba(0, 94, 110, 0.8),
      0 0 4px rgba(0, 94, 110, 0.8);
  }

  .glowing-border {
    box-shadow: 0 0 26px $text-shadow--cyan, 0 0 26px $text-shadow--cyan,
      0 0 26px $text-shadow--cyan, 0 0 26px $text-shadow--cyan,
      0 0 13px $text-shadow--cyan, 0 0 13px $text-shadow--cyan,
      0 0 6px rgba(0, 94, 110, 0.8), 0 0 6px rgba(0, 94, 110, 0.8) !important;
  }

  .header-row {
    width: 106%;
    margin-left: -3%;
  }

  .back-option {
    position: absolute;
    display: flex;
    width: 135px;
    height: 40px;
    left: 0;
    top: -30px;
    background: url(~@/assets/img/shop/btn-shop-back.png) center/100% 100%
      no-repeat;
    padding: 5px 0 0 45px;

    .back-arrow {
      position: absolute;
      top: 8px;
      left: 16px;
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-right: 15px solid white;
      margin-top: 3px;
    }
    .back-text {
      font-family: Ubuntu-Medium;
      font-size: 18px;
      color: white;
      text-transform: uppercase;
    }
  }

  .headline1 {
    color: $text-light-gold;
    font-size: 16px;
  }

  .package-name {
    font-size: 36px;
  }

  .package-image {
    height: 82px;

    .shop-more-percent {
      top: 0;
      right: 0;
      z-index: 1;
    }
  }

  .package-amount {
    font-size: 48px;
    line-height: 1;
  }

  .glow-box {
    border: 2px solid white;
    border-radius: 16px;
    width: 370px;
    height: 104px;

    .package-bonus-text {
      font-size: 21px;
      margin-top: 10px;
    }

    .icon {
      filter: drop-shadow(0 2px 12px $primary-accent);
      background-size: contain;
      background-repeat: no-repeat;
    }
  }

  .package-price-text {
    font-size: 16px;
    color: $text-light-gold;
  }

  .package-price-amount {
    background: #000000;
    border-radius: 8px;
    height: 48px;
    width: 216px;
    line-height: 48px;
    font-size: 32px;
    box-shadow: 0 0 1px #074f5c;
  }

  .pay-row {
    height: 300px;
    width: 570px;
    bottom: 50px;
    text-align: center;
    background-image: linear-gradient(
      $bg-gradient-steel-blue,
      $bg-gradient-midnight
    );
    box-shadow: 0 0 32px rgba(0, 0, 0, 0.1), 0 0 16px rgba(0, 0, 0, 0.27),
      0 0 8px rgba(0, 0, 0, 0.19);
    border-radius: 16px;

    .close-button {
      top: -20px;
      right: -20px;
    }

    .deco-button {
      width: 100%;
      height: 45px;
      font-size: 22.4px;
      font-family: Ubuntu;

      .deco-gem {
        display: none;
      }
    }
  }

  .text-choose-payment {
    top: 530px;
    font-size: 24px;
    text-align: center;
    font-family: Ubuntu-Bold;
    text-transform: uppercase;
  }

  .custom-table-head-left {
    width: 103%;
    left: -3%;
    top: 10px;
    z-index: 1;
  }
  .custom-table-head-right {
    width: 103%;
    right: -3%;
    top: 10px;
    z-index: 1;
  }
}
</style>
